import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import HappyCustomerServices from "../../services/HappyCustomerServices";

function AddHappyCustomer() {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    name: "",
    description: "",
    rating: "",
    video: "",
  });

  const [previewVideo, setPreviewVideo] = useState("");
  const [uploading, setUploading] = useState(false);

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;

    // If the field is 'video' and the value is a URL, set it directly
    if (name === "video" && value.startsWith("http")) {
      setFormValues({
        ...formValues,
        [name]: value,
      });
      setPreviewVideo(value); // Set preview for the URL
    } else {
      setFormValues({
        ...formValues,
        [name]: value,
      });
    }
  };

  // Handle video file upload
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploading(true);

    try {
      const formData = new FormData();
      formData.append("video", file);

      const response = await HappyCustomerServices.uploadVideo(formData);

      if (response && response.video) {
        const uploadedVideoPath = response.video.replace(/\\/g, "/"); // Normalize the path
        const videoURL = `${process.env.REACT_APP_URL}${uploadedVideoPath}`;
        setFormValues((prevValues) => ({
          ...prevValues,
          video: uploadedVideoPath, // Save the uploaded file path
        }));
        setPreviewVideo(videoURL);
      } else {
        alert("Failed to upload video. Please try again.");
      }
    } catch (error) {
      console.error("Video upload failed", error);
      alert("An error occurred during the video upload.");
    } finally {
      setUploading(false);
    }
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const { video, ...otherValues } = formValues;
      let payload = { ...otherValues };

      // Check if video is a URL or a file path
      if (video.startsWith("http")) {
        payload.video = video; // Save video URL
      } else {
        payload.video = video; // Save video file path
      }

      await HappyCustomerServices.createHappy(payload);
      alert("Happy Customer created successfully");
      navigate("/happy-customer");
    } catch (error) {
      console.error("Failed to create Happy Customer", error);
      alert("Failed to create Happy Customer");
    }
  };

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">
              Happy Customer Add                           </h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Customer Add
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <Link className="list-banner-btn" to="/happy-customer">
              List Happy Customer
            </Link>



          </div>
        </div>

        <div className="container-box">
          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 col-sm-6">
                    <div className="input-field">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={formValues.name}
                        onChange={handleInputChange}
                        placeholder="New name"
                    
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-6">
                    <div className="input-field">
                      <label>Rating</label>
                      <select
                        className="form-control"
                        value={formValues.rating}
                        onChange={handleInputChange}
                        name="rating"
                     
                      >
                        <option value="">Select Rating</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="input-field">
                      <label>Description</label>
                      <input
                        type="text"
                        name="description"
                        className="form-control"
                        value={formValues.description}
                        onChange={handleInputChange}
                        placeholder="New description"
                     
                      />
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="input-field">
                      <input
                        type="file"
                        name="video"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFileChange}
                        disabled={uploading}

                      />
                      {previewVideo && (
                        <div className="file-preview text-center mt-3">
                          <img
                            src={previewVideo}
                            alt="Preview"
                            style={{ maxWidth: "100%", maxHeight: "200px", objectFit: "cover" }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <button
                  className="submit-green-btn mt-4"
                  type="submit"
                  disabled={uploading}
                >
                  {uploading ? "Uploading..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddHappyCustomer;
